import { render, staticRenderFns } from "./public-portal-links-tab.vue?vue&type=template&id=4fb7586a"
import script from "./public-portal-links-tab.vue?vue&type=script&lang=js"
export * from "./public-portal-links-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports